import { useParams } from 'react-router'

export default function TextAreaResponseQuestion({ question, setAnswer }) {
  const { lng } = useParams()
  return (
    <div
      key={question.id}
      data-aos={`fade-up`}
      data-aos-delay={100}
      className="flex flex-col border-2 border-muted-300"
    >
      <h4 className="border-b-2 border-muted-300 bg-muted-100 px-4 py-3 font-bold">{question[`text_${lng}`]}</h4>
      <div className="flex flex-col gap-1 p-4">
        <textarea
          onChange={(event) =>
            setAnswer((pre) => ({
              ...pre,
              feedback: event.target.value,
            }))
          }
          maxLength={500}
          rows={4}
          placeholder="إمكانية إضافة مقترحات تساهم في تطوير المنصة..."
          className="border-2 border-muted-300 bg-muted-100 px-3 py-2 text-sm outline-none"
        />
      </div>
    </div>
  )
}
